import Box from "@components/Box";
import AsideNew from "@components/CaseStudyComponents/AsideNew";
import TestimonialSectionCaseStudy from "@components/LandingPageComponents/TestimonialSectionCaseStudy";
import { AppButton } from "@components/Typography";
import "keen-slider/keen-slider.min.css";
import Image from "next/image";
import React, { FC } from "react";
import AchievementCard from "../../components/CaseStudyComponents/AchievementCard";
import RelatedCaseStudies from "../../components/CaseStudyComponents/RelatedCaseStudies";
import NewLayout from "../../components/new-ui/Layout";

const property2x: FC = () => {
    const cardData = [
        {
            imgpath: "https://assets.gallabox.com/gb-home/property2x/property2x-icon1-new.png",
            title: "Reduction in call centre",
            count: "67%",
            by: "operational overheads",
            borderColor: "#ACDAF1",
            boxShadowColor: "white",
            fontColor: "#4299E1",
            gradient: "linear-gradient(105.67deg, rgba(215, 235, 245, 0.2) 0%, #D7EBF5 95.66%)",
        },
        {
            imgpath: "https://assets.gallabox.com/gb-home/property2x/property2x-icon2.png",
            title: "Save on marketing",
            count: "53%",
            by: "advertising costs ",
            borderColor: "#9AE6B4",
            boxShadowColor: "white",
            fontColor: "#38A169",
            gradient: "linear-gradient(285.78deg, #ECF8E1 3.17%, rgba(236, 248, 225, 0.2) 96.84%)",
        },
        {
            imgpath: "https://assets.gallabox.com/gb-home/property2x/property2x-icon3-new.png",
            title: "Increase in gross business",
            count: "300%",
            by: "profits(from 1 month)",
            borderColor: "#DEBEF3",
            boxShadowColor: "white",
            fontColor: "#805AD5",
            gradient: "linear-gradient(285.94deg, #EFE1F8 1.79%, rgba(239, 225, 248, 0.2) 98.89%)",
        },
    ];
    const redBoxPoints = ["Burgeoning Overhead Costs", "Disengaging Canned Responses", "Skyrocketing Marketing & Inventory"];
    const greenBoxPoints = ["Operational overheads reduced by 67%", "Marketing and inventory costs saved by 53%", "Gross business profits increased by 300%"];
    const RELATED_CASE_STUDIES = [
        {
            id: 1,
            bannerimg: "https://assets.gallabox.com/gb-home/case-study/case-study-banner-1.png",
            tag: "Travel & Tourism",
            title: "LivingStone Stays Relocated Their Communications From..",
            link: "/case-study/livingstone-stay",
            description:
                "Founded in 2019, LivingStone Stays is revolutionising the way people spend their leisure time - making holidays a way of life. Their platform is a one-stop ...",
        },
        {
            id: 2,
            bannerimg: "https://assets.gallabox.com/gb-home/case-study/case-study-banner-3.png",
            tag: "HR & Professional Service",
            title: "Jobstars India Deployed a Multilingual Chatbot to Handle 60%..",
            link: "/case-study/jobstars-india",
            description:
                "Founded in 2002, Jobstars is one of the leading players in the Indian recruitment ecosystem. They believe in combining their passion for people with smart investments ...",
        },
    ];

    return (
        <NewLayout
            title="Property2X real estate | WhatsApp Business customer story"
            description="Discover how Property2X boosted their gross profit by 300% in one month, cut call centre executives by half, and more using Gallabox WhatsApp Automation. "
            canonical="https://gallabox.com/case-study/property2x"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/property2x/property2x-og.jpg" }}
        >
            <header className="grid lg:pt-20 pt-0 pb-4 casestudy-main-header-new">
                <div className="hero-section h-full flex flex-col-reverse xl:flex-row px-4 xl:justify-between pt-12 lg:pt-0 mx-auto">
                    <div className="w-full h-full lg:w-1/2 lg:space-y-10 space-y-2 lg:pt-20 pt-10 order-1 lg:order-1 lg:overflow-hidden border-transparent">
                        <Image
                            width={483}
                            height={310}
                            alt="Enriched-Property2x-Image"
                            src="https://assets.gallabox.com/gb-home/property2x/property2x-header.png"
                            objectFit="scale-down"
                        />
                    </div>
                    <div className="h-full w-full lg:w-1/2 order-2 lg:order-2 lg:space-y-10 space-y-2 lg:pt-24">
                        <h1 className="font-semibold text-blue-800 text-3xl lg:text-4xl lg:leading-tight">
                            How Property2X Used Gallabox to Achieve a 300% Increase in Gross Profit
                        </h1>
                        <div className="text-xl text-biscay">
                            Discover how Property2X boosted their gross profit by 300% in one month, cut call centre executives by half, and more, all thanks to Gallabox!
                        </div>
                    </div>
                </div>
            </header>

            <div>
                <section className="max-w-6xl mx-auto flex flex-col items-center sm:flex-row gap-5 my-20 justify-between ">
                    {cardData.map((eachobj) => {
                        return (
                            <AchievementCard
                                key={""}
                                imagePath={eachobj.imgpath}
                                imageTitle={eachobj.title}
                                count={eachobj.count}
                                by={eachobj.by}
                                borderColor={eachobj.borderColor}
                                boxShadowColor={eachobj.boxShadowColor}
                                fontColor={eachobj.fontColor}
                                gradient={eachobj.gradient}
                            />
                        );
                    })}
                </section>
            </div>
            <div className=" mx-auto mt-20 lg:px-0 px-4">
                <div className="max-w-6xl mx-auto flex flex-col sm:flex-row gap-8">
                    <div className=" mx-auto lg:w-64  ">
                        <AsideNew
                            data={[
                                {
                                    title: "Company",
                                    content: "Property2X",
                                },
                                {
                                    title: "Industry",
                                    content: "Real Estate",
                                },
                                {
                                    title: "Employees",
                                    content: "21-50",
                                },

                                {
                                    title: "Features Used",
                                    content: [" Multilingual Chatbot", "Shared Team Inbox", "WhatsApp Broadcasts", "Drip Marketing aka Sequence", "Spreadsheet Integration"],
                                },
                                {
                                    title: "Chats per Month",
                                    content: "5k+",
                                },
                            ]}
                        />
                        <div className=" sm:sticky top-24 pt-4">
                            <Box title="Pain Points 🥲" points={redBoxPoints} bgColor="red-50" textColor="red-700" />
                            <Box title="Results 🤩" points={greenBoxPoints} bgColor="green-50" textColor="green-600" />
                        </div>
                    </div>
                    <main className="space-y-20 lg:px-8 px-4   ">
                        <div>
                            <h2 className="lg:text-5xl text-2xl font-bold pb-10" style={{ color: "#4A5568" }}>
                                The Tale of Property2X
                            </h2>
                            <p className="lg:text-lg text-base pb-10 text-gray-500 ">
                                Property2X is a renowned venture of Molgain Infra and Realtors. Their efficient platform offers undeniably genuine real estate investment
                                opportunities. However, their platform is not a high-stakes venture that depends on instincts. On the contrary, the Property2X team performs a
                                meticulous due diligence process prior to listing any property on their site.
                            </p>
                            <p className="lg:text-lg text-base  text-gray-500">
                                Although they have significant prominence in the Delhi NCR region, ongoing expansion plans include other cities as well. Property2X is a lucrative
                                channel for real estate investors seeking multiple returns matching their requirements and timelines. The prospect of guaranteed returns is
                                universally appealing to all investors.
                            </p>
                        </div>
                        <div>
                            <h2 className="lg:text-5xl text-2xl  font-bold pb-10" style={{ color: "#4A5568" }}>
                                Challenges Encountered by Property2X 😥
                            </h2>
                            <div className="space-y-10">
                                <p className="lg:text-lg text-base text-gray-500">
                                    Managing a real estate business has never been a walk in the park, and Property2X sure had their fair share of roadblocks.
                                </p>
                                <div>
                                    {" "}
                                    <h3 className="text-2xl text-gray-500 font-semibold">Burgeoning Overhead Costs</h3>
                                    <p className="lg:text-lg text-base  text-gray-500">
                                        In many respects, the term &apos;manual intervention&apos; can be interpreted as &apos;inefficient utilization of resources.&apos; The
                                        painstaking approach to handling every minute detail manually can result in a significant expenditure of time and capital that might
                                        otherwise be engaged more effectively.
                                    </p>
                                </div>
                                <div>
                                    {" "}
                                    <h3 className="text-2xl text-gray-500 font-semibold">Canned Responses Causing Disengagement</h3>
                                    <p className="lg:text-lg text-base text-gray-500">
                                        There&apos;s a typical unease that stems from receiving a response that seems to be strikingly &apos;copied and pasted&apos;. That&apos;s
                                        essentially the concern in focus here. It became apparent that such templated responses were not exactly igniting much enthusiasm.
                                    </p>
                                </div>
                                <div>
                                    {" "}
                                    <h3 className="text-2xl text-gray-500 font-semibold">Skyrocketing Marketing and Inventory Expenses</h3>
                                    <p className="lg:text-lg text-base  text-gray-500">
                                        It is certainly surprising to realise that the idiom &apos;ignorance isn&apos;t bliss&apos; holds true in regard to expenses! The rise in
                                        marketing and inventory costs was due in part to a lack of comprehensive analytics, leading to an obscured strategic approach.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div>
                            <h2 className="lg:text-4xl text-2xl  font-bold pb-10" style={{ color: "#4A5568" }}>
                                Property2X&apos;s Partnership with Gallabox for WhatsApp Automation
                            </h2>
                            <div className="space-y-10">
                                <p className="lg:text-lg text-base  text-gray-500">
                                    Property2X was struggling to find ways to streamline their operations, eliminate inefficiencies, and reduce costs. Gallabox, a WhatsApp business
                                    automation solution, offered them all the tools they needed to achieve their goals.
                                </p>
                                <p className="lg:text-lg text-base  text-gray-500">
                                    Gallabox&apos;s platform enables businesses to automate their WhatsApp communications. This allows businesses to save time and money, while also
                                    providing a better customer experience. Property2X has been able to use Gallabox&apos;s platform to improve its customer service, accelerate the
                                    sales cycle, and cut down on expenses.
                                </p>
                                <div>
                                    {" "}
                                    <h3 className="text-2xl pb-5 text-gray-500 font-semibold">Getting a Grip on Greedy Overhead Costs</h3>
                                    <p className="lg:text-lg text-base  text-gray-500">
                                        Gallabox helped Property2X significantly reduce their overhead costs with intelligent chatbots that worked around the clock. These tireless
                                        digital assistants answered repetitive questions, freeing up human employees to focus on more complex tasks.
                                    </p>
                                </div>
                                <TestimonialSectionCaseStudy
                                    testimonialData={{
                                        headerTitle:
                                            "In today's world of instant gratification, the ability to answer customer queries quickly and accurately is not just an advantage, it's a necessity",
                                        avatarImg: "https://assets.gallabox.com/gb-home/property2x/property2x-owner.png",
                                        nameText: "Mr. Satendra Singh Tomar",
                                        professionText: "Co-Founder and CEO, Property2X",
                                    }}
                                />

                                <p className="lg:text-lg text-base  text-gray-500">
                                    These chatbots didn&apos;t just answer questions. They also gathered data for lead qualification. That&apos;s like having an assistant who never
                                    sleeps - and never asks for a raise!
                                </p>

                                <ol className="lg:text-lg text-base text-gray-500">
                                    <li>24/7 customer service? Check.</li>
                                    <li>Elevated customer satisfaction? Obviously!</li>
                                    <li>A streamlined operation with reduced overheads? You bet :)</li>
                                </ol>

                                <div className=" space-y-4">
                                    {" "}
                                    <h3 className="text-2xl text-gray-500 font-semibold">Trading Canned for Candid with Gallabox</h3>
                                    <p className="lg:text-lg text-base  text-gray-500">
                                        How often do customers encounter a robotic, impassive response from businesses? A touch of human warmth can make a significant difference.
                                        Stripping away the clichéd rehearsed responses, Gallabox empowered Property2X with a fusion that was a perfect balance of personalisation
                                        and automation.
                                    </p>
                                    <p className="lg:text-lg text-base  text-gray-500">
                                        By adding a human touch to all automated conversations Property2X transformed their sales prospecting experience. While the shared team
                                        inbox made conversations transparent, other features like chatbot-powered lead qualification accelerated their sales process.
                                    </p>
                                </div>
                                <div className=" space-y-4">
                                    {" "}
                                    <h3 className="text-2xl text-gray-500 font-semibold">Thrifty on Inventory and Marketing Expenditure</h3>
                                    <p className="lg:text-lg text-base  text-gray-500">
                                        Juggling expensive inventory and flamboyant marketing campaigns can be an epic drain on the company fund pool.
                                    </p>
                                    <p className="lg:text-lg text-base  text-gray-500">
                                        However, after implementing Gallabox, Property2X witnessed a whopper 50% drop in capital expenditure on marketing while also slicing their
                                        inventory management costs in half. Features like segmented broadcasts, drip marketing, and actionable analytics revved up their growth
                                        engine by reducing spend and increasing ROI.
                                    </p>
                                </div>
                                <TestimonialSectionCaseStudy
                                    testimonialData={{
                                        headerTitle:
                                            "Gallabox helped reduce our call centre executives by 50% and cut down our inventory and marketing costs by half. Also, the platform's automation and personalisation features are the best in the market. Most impressively, our gross profit grew by 300% within a month.",
                                        avatarImg: "https://assets.gallabox.com/gb-home/property2x/property2x-owner.png",
                                        nameText: "Mr. Satendra Singh Tomar",
                                        professionText: "Co-Founder and CEO, Property2X",
                                    }}
                                />
                            </div>
                        </div>
                    </main>
                </div>
            </div>

            <section style={{ backgroundColor: "#FFED82" }} className="flex flex-col items-center justify-center">
                <div className="max-w-6xl mx-auto px-4 md:px-20 py-8">
                    <h2 className="font-bold text-3xl text-center text-yellow-800" style={{ fontSize: "26px" }}>
                        Are you ready to replicate the success story <br /> of Property2X?
                    </h2>
                    <div className="flex justify-center mt-4">
                        {" "}
                        <AppButton buttonText="Get Started" href="https://app.gallabox.com/signup" />
                    </div>
                </div>
            </section>

            <RelatedCaseStudies sectionDescription="Related Case Studies" related={RELATED_CASE_STUDIES} />

            <style jsx>{`
                .casestudy-main-header-new {
                    background-color: #fcf9f1;
                    background-position: center;
                    background-repeat: no-repeat;
                    background-size: cover;
                    width: 100vw;
                    height: 500px;
                }
                .casestudy-main-header-new h1 {
                    font-family: Google Sans;
                    font-style: normal;
                    letter-spacing: 0.02em;
                    color: #162c6f;
                }
                .casestudy-main-header-new .top-text {
                    font-weight: 500;
                    font-size: 30px;
                    line-height: 38px;
                }
                .casestudy-main-header-new .bottom-text {
                    font-weight: 700;
                    font-size: 50px;
                    line-height: 64px;
                }
                .case-study-bluebox-slider {
                    font-family: "Google Sans";
                    font-style: normal;
                    letter-spacing: 0.05em;
                    color: #4a5568;
                    background-color: #ffffff;
                    box-shadow: 2.01005px 2.01005px 10.0503px rgba(51, 100, 250, 0.2), inset 0px 0px 10.0503px rgba(122, 152, 244, 0.1);
                    border-radius: 10.0503px;
                }
                .slider-profile-name {
                    font-weight: 700;
                    font-size: 22.1106px;
                    width: fit-content;
                    line-height: 28px;
                }
                .slider-content {
                    font-style: italic;
                    font-weight: 500;
                    font-size: 26.1307px;
                    line-height: 40px;
                    width: fit-content;
                }
                .slider-profile-about {
                    font-weight: 400;
                    font-size: 17.9834px;
                    line-height: 23px;
                    text-align: center;
                }
                .case-study-tag-filter {
                    font-family: "Google Sans";
                    font-style: normal;
                    font-weight: 400;
                    font-size: 14.9744px;
                    line-height: 19px;
                    letter-spacing: 0.02em;
                    color: #2d3748;
                }
                .case-study-filter-checkbox {
                    width: 18px;
                    height: 18px;
                    background-color: #ffffff;
                    border: 1.5px solid #0083ff;
                    border-radius: 2px;
                }
                .case-study-carousal {
                    border-radius: 10px;
                }
                .case-study-carousal-content {
                    font-family: "Google Sans";
                    font-style: normal;
                    font-weight: 500;
                    font-size: 24px;
                    line-height: 40px;
                    letter-spacing: 0.02em;
                    color: #ffffff;
                }
                .case-study-carousal .redirect {
                    font-family: "Google Sans";
                    font-style: normal;
                    font-weight: 400;
                    font-size: 15px;
                    line-height: 19px;
                    letter-spacing: 0.02em;
                    color: #bababa;
                }
                .case-study-carousal .redirect::after {
                    content: url("https://assets.gallabox.com/gb-home/case-study/redirect-arrow.png");
                    position: relative;
                    left: 4px;
                    top: 2px;
                }
                .carousal-img {
                    width: 530px;
                    background-color: #d9d9d9;
                    border-radius: 4.99649px;
                }
                .filter-title-case-study {
                    font-family: "Google Sans";
                    font-style: normal;
                    font-weight: 500;
                    font-size: 15px;
                    line-height: 19px;
                    text-align: center;
                    letter-spacing: 0.02em;
                    color: #838383;
                }
                .slider-btn-right {
                    position: absolute;
                    top: 150px;
                    right: -35px;
                    z-index: 5;
                }
                .slider-btn-left {
                    position: absolute;
                    top: 150px;
                    left: -35px;
                    z-index: 5;
                }
                .slide-count-case-study {
                    width: 60px;
                    height: 60px;
                    color: #3364fa;
                    background-color: #ffffff;
                    border: 1px solid rgba(51, 100, 250, 0.1);
                    border-radius: 50%;
                    box-shadow: 2px 2px 10px rgba(51, 100, 250, 0.2), inset 0px 0px 10px rgba(122, 152, 244, 0.1);
                }
                .left-arrow {
                    width: 30px;
                    height: 30px;
                    background-color: #ffffff;
                    border: 1px solid rgba(51, 100, 250, 0.1);
                    border-radius: 50%;
                    box-shadow: 2px 2px 10px rgba(51, 100, 250, 0.2), inset 0px 0px 10px rgba(122, 152, 244, 0.1);
                }
                .right-arrow {
                    width: 30px;
                    height: 30px;
                    background-color: #ffffff;
                    border: 1px solid rgba(51, 100, 250, 0.1);
                    border-radius: 50%;
                    box-shadow: 2px 2px 10px rgba(51, 100, 250, 0.2), inset 0px 0px 10px rgba(122, 152, 244, 0.1);
                }

                @media (max-width: 35rem) {
                    .casestudy-main-header-new {
                        background-size: contain;
                        height: 100%;
                    }
                    .casestudy-main-header-new .top-text {
                        font-size: 20px;
                    }
                    .casestudy-main-header-new .bottom-text {
                        font-size: 30px;
                        padding-inline: 1rem;
                        line-height: 35px;
                        margin-top: 0.7rem;
                    }
                    .case-study-carousal {
                        border-radius: 10px;
                    }
                    .carousal-img {
                        width: 100%;
                    }
                    .case-study-carousal-content {
                        font-size: 18px;
                        line-height: 28px;
                        padding-inline: 1rem;
                        margin-top: 0.5rem;
                        margin-bottom: 1rem;
                    }
                    .slide-count-case-study {
                        width: 50px;
                        height: 50px;
                    }
                    .left-arrow {
                        width: 30px;
                        height: 30px;
                    }
                    .right-arrow {
                        width: 30px;
                        height: 30px;
                    }
                    .slider-profile-name {
                        font-size: 19px;
                        line-height: 30px;
                    }
                    .slider-profile-about {
                        font-size: 18px;
                        line-height: 23px;
                    }
                    .slider-content {
                        font-size: 16px;
                        line-height: 23px;
                    }
                    .slider-btn-right {
                        top: 180px;
                        right: -5px;
                        width: 3rem;
                    }
                    .slider-btn-left {
                        top: 180px;
                        left: -5px;
                        width: 3rem;
                    }
                }
            `}</style>
        </NewLayout>
    );
};

export default property2x;
